// components/FilterDropdown.tsx
import React, { useMemo, useCallback } from 'react';
import { Typography, FormGroup, FormControlLabel, Checkbox, Skeleton, Box } from '@mui/material';
import { useFilterData } from './useFilterData';


interface FilterDropdownProps {
  url: string;
  title: string;
  selectedIds: number[];
  onChange: (ids: number[]) => void;
}

export const FilterDropdown: React.FC<FilterDropdownProps> = ({
  url,
  title,
  selectedIds,
  onChange,
}) => {
  const { data, loading, error } = useFilterData(url);
  const selectedSet = useMemo(() => new Set(selectedIds), [selectedIds]);

  const handleChange = useCallback((id: number, checked: boolean) => {
    const newSelectedIds = checked
      ? [...selectedIds, id]
      : selectedIds.filter(selectedId => selectedId !== id);
    onChange(newSelectedIds);
  }, [selectedIds, onChange]);

  if (loading) {
    return (
      <Typography className="filter-dropdown-title cursor-pointer" variant="subtitle2" gutterBottom>{title} </Typography>
    );
  }

  if (error) {
    return (
      <div>
        <Typography color="error">{title}: Failed to load</Typography>
      </div>
    );
  }

  return (
    <div >
      <Typography className="filter-dropdown-title cursor-pointer" variant="subtitle2" gutterBottom> {title} </Typography>
      <Box >
      <FormGroup>
        {data.map((item) => (
          <FormControlLabel
            className="filter-dropdown-option"
            key={item.id}
            control={
              <Checkbox
                checked={selectedSet.has(item.id)}
                onChange={(e) => handleChange(item.id, e.target.checked)}
                size="small"
              />
            }
            label={item.name}
          />
        ))}
      </FormGroup>
      </Box>
    </div>
  );
};